import moment from "moment";
import { PeriodDates } from "./TimePeriods";

/*****
 *
 * PARSE DIFFERENT DATE STRINGS FROM THE UI
 *
 *   */
const DATE_FORMATS = [
    "YYYY-MM-DD h:mm:ss a",
    "YYYY-MM-DDTh:mm:ss a",
    "DD-MM-YYYY",
    "MM/DD/YYYY",
    "MMM DD, YYYY",
];

export const DATE_FORMAT = "MM-DD-YYYY";

export function extractDate(rawDateText: string) {
    for (let format of DATE_FORMATS) {
        const parsedDate = moment(rawDateText, format);

        if (parsedDate.isValid()) {
            return parsedDate;
        }
    }
}
export function momentDate(date: Date | undefined): moment.Moment | undefined {
    if (date === undefined) return undefined;
    return moment(date);
}

export function formatDetailDate(dateObj: moment.Moment | undefined) {
    if (undefined) return "";
    return dateObj?.format("MM-DD-YYYY h:mm:ss a");
}

export function formatDateString(date: string | Date) {
    return formatDate(moment(date));
}

/** "Mar. 5, 2025" */
export function formatDateMonthName(date: string | Date) {
    return moment(date).format("MMM. D, YYYY");
}

export function formatDate(dateObj: moment.Moment | undefined): string {
    if (dateObj === undefined || !dateObj.isValid()) return "";
    return dateObj.format(DATE_FORMAT);
}

export function getTimeOfDay() {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 5 && hours < 12) {
        return "morning";
    } else if (hours >= 12 && hours < 17) {
        return "afternoon";
    } else {
        return "evening";
    }
}

export function getNextMonthDates(): PeriodDates {
    const now = moment();

    const nextMonthStart = now.clone().add(1, "months").startOf("month");

    const nextMonthEnd = now.clone().add(1, "months").endOf("month");

    return {
        startDate: nextMonthStart.toDate(),
        endDate: nextMonthEnd.toDate(),
    };
}

export function formatUTCDate(date?: Date | string) {
    if (!date) return "";
    const momentDate = handleUTCDate(date);
    return momentDate.format(DATE_FORMAT);
}

export function handleUTCDate(date?: Date | string) {
    return moment.parseZone(date);
}

export function formatDateTime(date?: Date | string) {
    if (!date) return "";
    return moment(date).format("MMM D, YYYY h:mm A");
}

export function formatDateSlashes(date?: Date | string) {
    if (!date) return "";
    return moment(date).format("MM/DD/YYYY");
}

/**
 * How long ago (or until) a date is, as moment words it ("3 days ago"),
 * except that anything under moment's own 45-second "a few seconds" bucket
 * reads "now".
 */
export function getRelativeTime(date?: Date | string, ...args: [withoutSuffix?: boolean]) {
    if (!date) return "";
    const then = moment(date);
    if (Math.abs(moment().diff(then, "seconds")) < 45) return "now";
    return then.fromNow(...args);
}

export function getTimeDuration(date?: Date | string) {
    const created = moment(date);
    const now = moment();

    const seconds = now.diff(created, "seconds");
    const minutes = now.diff(created, "minutes");
    const hours = now.diff(created, "hours");
    const days = now.diff(created, "days");
    const months = now.diff(created, "months");
    const years = now.diff(created, "years");

    if (seconds < 60) return `${seconds} second${seconds !== 1 ? "s" : ""} `;
    if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""}`;
    if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""}`;
    if (days < 30) return `${days} day${days !== 1 ? "s" : ""}`;
    if (months < 12) return `${months} month${months !== 1 ? "s" : ""} `;
    return `${years} year${years !== 1 ? "s" : ""}`;
}
